import { render, staticRenderFns } from "./FooterInfo.vue?vue&type=template&id=24b27494&scoped=true&"
import script from "./FooterInfo.vue?vue&type=script&lang=ts&"
export * from "./FooterInfo.vue?vue&type=script&lang=ts&"
import style0 from "./FooterInfo.vue?vue&type=style&index=0&id=24b27494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b27494",
  null
  
)

export default component.exports